export default "__VITE_ASSET__BCp9MRTD__"